import { PaperPlaneRightIcon } from "@phosphor-icons/react/dist/csr/PaperPlaneRight";
import { Fragment } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Alert } from "@volca/ui/components/ui/alert";
import { ActionPreview } from "./examples/example-ui/action-preview";
import { GuideArticle } from "./guide-article";
import { GuideBefore } from "./guide-before";
import { GuideChecks } from "./guide-checks";
import { GuideExample } from "./guide-example";
import { GuideStep } from "./guide-step";
import type { HelpGuide } from "./types";

export const WrittenGuide = ({ guide }: { guide: HelpGuide }) => (
  <GuideArticle
    previewId={
      guide.previews?.length || guide.example ? "guide-example" : undefined
    }
    lead={guide.intro}
  >
    <GuideBefore>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{guide.before}</ReactMarkdown>
    </GuideBefore>
    {guide.sections.map((section, index) => (
      <Fragment key={section.title}>
        <GuideStep
          id={`guide-step-${index}`}
          step={index + 1}
          title={section.title}
        >
          {section.callout && (
            <Alert role="note" className="mt-4">
              <p className="font-semibold text-ink">{section.callout.title}</p>
              <p className="mt-1">{section.callout.body}</p>
            </Alert>
          )}
          <ReactMarkdown>{section.body}</ReactMarkdown>
          {section.buttonReference && (
            <p>
              <ActionPreview
                leftIcon={
                  section.buttonReference.icon === "send" ? (
                    <PaperPlaneRightIcon className="size-4" />
                  ) : undefined
                }
              >
                {section.buttonReference.label}
              </ActionPreview>
            </p>
          )}
        </GuideStep>
        {guide.previews
          ? guide.previews
              .filter((preview) => preview.afterStep === index + 1)
              .map((preview) => (
                <GuideExample
                  key={preview.afterStep}
                  id={
                    preview === guide.previews?.[0]
                      ? "guide-example"
                      : `guide-example-${preview.afterStep}`
                  }
                  kind={preview.kind}
                  interactive={preview.interactive}
                  task={preview.caption}
                />
              ))
          : index === 1 &&
            guide.example &&
            guide.task && (
              <GuideExample kind={guide.example} task={guide.task} />
            )}
      </Fragment>
    ))}
    <GuideChecks checks={guide.checks} problem={guide.problem} />
  </GuideArticle>
);
